import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useVendorsUrl } from '../routes';

const VendorsBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useVendorsUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Vendors" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default VendorsBreadcrumbs;
